import baseRequest from "../_core/baseRequest";

export default {
    getTicketTypes: params => {
        const queryParams = new URLSearchParams();
        if (params?.name) queryParams.append("name", params.name);
        if (params?.category) queryParams.append("category", params.category);
        if (params?.topic) queryParams.append("topic", params.topic);
        if (params?.skip !== undefined) queryParams.append("skip", params.skip);
        if (params?.limit !== undefined) queryParams.append("limit", params.limit);
        return baseRequest.get(
            `/ticket-types/list?${queryParams.toString().replace(/\+/g, "%20")}`
        );
    },
    getTicketTypeOptions: category =>
        baseRequest.get(`/ticket-types/options?category=${encodeURIComponent(category)}`),
    createTicketType: params => baseRequest.post("/ticket-types/", params),
    updateTicketType: (id, params) => baseRequest.put(`/ticket-types/${id}`, params),
    deleteTicketType: id => baseRequest.patch(`/ticket-types/${id}/soft-delete`)
};
